import React, { useState, useEffect, useContext, useRef } from "react";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { useMediaQuery, useTheme } from '@material-ui/core';
import { isNil } from "lodash";
import {
  CircularProgress,
  ClickAwayListener,
  IconButton,
  InputBase,
  makeStyles,
  Paper,
  Hidden,
  Menu,
  MenuItem,
  Tooltip,
  Fab,
} from "@material-ui/core";
import {
  blue,
  green,
  pink,
  grey,
} from "@material-ui/core/colors";
import {
  AttachFile,
  CheckCircleOutline,
  Clear,
  Comment,
  Create,
  Description,
  HighlightOff,
  Mic,
  Mood,
  MoreVert,
  Send,
  PermMedia,
  Person,
  Room,
  Reply,
  Duo,
  Timer,
} from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import BoltIcon from '@mui/icons-material/FlashOn';
import { CameraAlt } from "@material-ui/icons";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";

import useQuickMessages from "../../hooks/useQuickMessages";
import { isString, isEmpty } from "lodash";
import ContactSendModal from "../ContactSendModal";
import CameraModal from "../CameraModal";
import axios from "axios";
import ButtonModal from "../ButtonModal";
import MenuIcon from '@material-ui/icons/Menu';
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import MessageUploadMedias from "../MessageUploadMedias";
import KoraxFollowUpModal from "../KoraxFollowUpModal";
import KoraxFormSendDialog from "../KoraxFormSendDialog";
import KoraxFormHistoryDialog from "../KoraxFormHistoryDialog";
import KoraxFormPendingBadge from "../KoraxFormPendingBadge";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";

import LocationModal from "../LocationModal";


const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    flex: "0 0 auto",
    width: "100%",
    boxSizing: "border-box",

    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",

    background:
      theme.mode === "light"
        ? "rgba(255,255,255,.98)"
        : "rgba(15,23,42,.98)",

    borderTop:
      theme.mode === "light"
        ? "1px solid #E4E7EC"
        : "1px solid rgba(148,163,184,.18)",

    boxShadow:
      theme.mode === "light"
        ? "0 -8px 24px rgba(15,23,42,.07)"
        : "0 -10px 28px rgba(0,0,0,.30)",

    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",

    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      left: 0,
      right: 0,
      bottom: 0,

      width: "100%",
      maxWidth: "100vw",
      margin: 0,

      zIndex: 1100,
      boxSizing: "border-box",

      paddingBottom: "env(safe-area-inset-bottom)",

      transform: "translateZ(0)",
      WebkitTransform: "translateZ(0)"
    },
  },
  avatar: {
    width: "50px",
    height: "50px",
    borderRadius: "25%",
  },
  dropInfo: {
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: 15,
    left: 0,
    right: 0,
  },
  dropInfoOut: {
    display: "none",
  },
  gridFiles: {
    maxHeight: "100%",
    overflow: "scroll",
  },
  blockedConversationBox: {
    width: "100%",
    padding: "12px 14px",
    background: "#FFFFFF",
    borderTop: "1px solid #E2E8F0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    boxSizing: "border-box",
  },
  blockedCard: {
    width: "100%",
    maxWidth: 620,
    borderRadius: 18,
    background: "linear-gradient(135deg, #F8FAFC, #FFFFFF)",
    border: "1px solid #E2E8F0",
    boxShadow: "0 10px 28px rgba(15,23,42,.06)",
    padding: "12px 14px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    [theme.breakpoints.down("sm")]: {
      padding: "10px 11px",
      borderRadius: 16,
    },
  },
  blockedIcon: {
    width: 42,
    height: 42,
    borderRadius: 15,
    background: "rgba(37,99,235,.10)",
    color: "#2563EB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
    flexShrink: 0,
  },
  blockedTitle: {
    color: "#0F172A",
    fontWeight: 950,
    fontSize: 13,
  },
  blockedSubtitle: {
    color: "#64748B",
    fontSize: 12,
    marginTop: 2,
  },
  blockedButton: {
    border: "none",
    borderRadius: 999,
    background: "linear-gradient(135deg, #2563EB, #1D4ED8)",
    color: "#FFFFFF",
    fontWeight: 900,
    padding: "9px 14px",
    cursor: "pointer",
    whiteSpace: "nowrap",
    boxShadow: "0 10px 22px rgba(37,99,235,.20)",
    [theme.breakpoints.down("sm")]: {
      padding: "8px 11px",
      fontSize: 12,
    },
  },

  newMessageBox: {
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",

    display: "flex",
    alignItems: "center",
    gap: 7,

    padding: "8px 10px",
    background: "transparent",

    [theme.breakpoints.down("sm")]: {
      minHeight: 64,
      gap: 5,
      padding: "7px 8px",
      overflow: "visible",

      "& .MuiIconButton-root": {
        width: 36,
        height: 36,
        padding: 6,
        flexShrink: 0
      },

      "& .MuiSvgIcon-root": {
        fontSize: "1.12rem"
      }
    },
  },
  messageInputWrapper: {
    flex: 1,
    minWidth: 0,
    minHeight: 42,
    maxHeight: 112,

    display: "flex",
    alignItems: "center",
    position: "relative",

    margin: 0,
    padding: "7px 12px",

    borderRadius: 14,
    border:
      theme.mode === "light"
        ? "1px solid #D0D5DD"
        : "1px solid rgba(148,163,184,.24)",

    background:
      theme.mode === "light"
        ? "#F8FAFC"
        : "#182230",

    boxShadow: "inset 0 1px 2px rgba(15,23,42,.03)",
    transition: "all .16s ease",

    "&:focus-within": {
      borderColor: theme.palette.primary.main,
      background:
        theme.mode === "light"
          ? "#FFFFFF"
          : "#1E293B",
      boxShadow: "0 0 0 3px rgba(21,94,239,.11)"
    },

    [theme.breakpoints.down("sm")]: {
      minHeight: 44,
      maxHeight: 88,
      padding: "6px 10px",
      borderRadius: 15
    },
  },
  messageInputWrapperPrivate: {
    padding: 6,
    marginRight: 7,
    background: "#F0E68C",
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
  },
  messageInput: {
    flex: 1,
    minWidth: 0,
    padding: "0 2px",

    border: "none",
    background: "transparent",

    color:
      theme.mode === "light"
        ? "#101828"
        : "#F8FAFC",

    fontSize: "0.86rem",
    lineHeight: 1.4,

    "& textarea": {
      maxHeight: 88,
      overflowY: "auto !important"
    },

    "& input::placeholder, & textarea::placeholder": {
      color:
        theme.mode === "light"
          ? "#98A2B3"
          : "#64748B",
      opacity: 1
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "0.88rem",
      lineHeight: 1.35,

      "& textarea": {
        maxHeight: 68
      }
    },
  },
  messageInputPrivate: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    color: grey[800],

  },
  sendMessageIcons: {
  color: "#64748B",
  fontSize: "1.18rem",
  transition: "all 0.18s ease",
  "&:hover": {
    color: "#2563EB",
    transform: "scale(1.05)",
  },
},
  ForwardMessageIcons: {
    color: grey[700],
    transform: 'scaleX(-1)'
  },
  uploadInput: {
    display: "none",
  },
  viewMediaInputWrapper: {
    maxHeight: "100%",
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.mode === 'light' ? "#ffffff" : "#202c33",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },
  

emojiBox: {
  position: "absolute",
  bottom: 72,
  left: 8,
  zIndex: 9999,

  "& .emoji-mart": {
    width: 340,
    border: "1px solid rgba(15,23,42,0.08) !important",
    borderRadius: "20px !important",
    overflow: "hidden",
    background: "#ffffff !important",
    boxShadow: "0 20px 60px rgba(15,23,42,0.18) !important",
    fontFamily: "inherit",
  },

  "& .emoji-mart-bar": {
    borderColor: "rgba(15,23,42,0.05) !important",
    background: "#ffffff !important",
  },

  "& .emoji-mart-search": {
    padding: "12px !important",
    marginBottom: 0,
  },

  "& .emoji-mart-search input": {
    borderRadius: "12px !important",
    border: "1px solid rgba(15,23,42,0.08) !important",
    background: "#f8fafc !important",
    color: "#0f172a !important",
    fontSize: "0.82rem",
    padding: "10px 12px !important",
    boxShadow: "none !important",
  },

  "& .emoji-mart-category-label span": {
    background: "#ffffff !important",
    color: "#64748b !important",
    fontWeight: 600,
    fontSize: "0.72rem",
  },

  "& .emoji-mart-scroll": {
    padding: "0 6px 6px",
  },

  "& .emoji-mart-anchor": {
    color: "#94a3b8 !important",
  },

  "& .emoji-mart-anchor-selected": {
    color: "#2563eb !important",
  },

  "& .emoji-mart-preview": {
    display: "none",
  },

  "& .emoji-mart-emoji:hover:before": {
    background: "rgba(37,99,235,0.08) !important",
    borderRadius: "10px",
  },

  "& .emoji-mart-scroll::-webkit-scrollbar": {
    width: 6,
  },

  "& .emoji-mart-scroll::-webkit-scrollbar-thumb": {
    background: "rgba(148,163,184,0.35)",
    borderRadius: 20,
  },
},



  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },
  audioLoading: {
    color: green[500],
    opacity: "70%",
  },
  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
    [theme.breakpoints.down("sm")]: {
      flex: "1 1 auto",
      minWidth: 0,
      width: "100%",
      justifyContent: "space-between",
      "& .MuiIconButton-root": {
        flexShrink: 0
      }
    },
  },
  cancelAudioIcon: {
    color: "red",
  },
  sendAudioIcon: {
    color: "green",
  },
  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
    backgroundColor: theme.palette.optionsBackground,
  },
  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: theme.mode === "light" ? "#f0f0f0" : "#1d282f", //"rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },
  replyginMsgBody: {
    padding: 8,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },
  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },
  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },
  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "54px",
    background:
      theme.mode === "light"
        ? "linear-gradient(165deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)"
        : "linear-gradient(165deg, rgba(30,41,59,0.96) 0%, rgba(15,23,42,0.96) 100%)",
    padding: 4,
    border: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.26)" : "rgba(148,163,184,0.36)"}`,
    borderRadius: 14,
    boxShadow:
      theme.mode === "light"
        ? "0 14px 30px rgba(15,23,42,0.16)"
        : "0 16px 30px rgba(0,0,0,0.45)",
    backdropFilter: "blur(6px)",
    left: 0,
    width: "100%",
    zIndex: 30,
    maxHeight: 290,
    overflowY: "auto",
    ...theme.scrollbarStyles,
    animation: "$quickAnswersReveal 0.18s ease-out",
    "& li": {
      listStyle: "none",
    },
  },
  "@keyframes quickAnswersReveal": {
    "0%": {
      opacity: 0,
      transform: "translateY(6px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  messageQuickAnswersWrapperItem: {
    borderBottom: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.22)" : "rgba(148,163,184,0.32)"}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  messageQuickAnswerLink: {
    display: "block",
    padding: "9px 11px",
    cursor: "pointer",
    textDecoration: "none",
    borderRadius: 10,
    transition: "all .16s ease",
    "&:hover": {
      background:
        theme.mode === "light"
          ? "linear-gradient(145deg, rgba(37,99,235,0.12), rgba(14,165,233,0.08))"
          : "linear-gradient(145deg, rgba(59,130,246,0.2), rgba(14,165,233,0.12))",
    },
  },
  messageQuickAnswerShortcut: {
    display: "block",
    fontWeight: 700,
    fontSize: "0.81rem",
    color: theme.mode === "light" ? "#0f172a" : "#f1f5f9",
    lineHeight: 1.25,
    marginBottom: 3,
  },
  messageQuickAnswerPreview: {
    display: "block",
    fontSize: "0.73rem",
    color: theme.mode === "light" ? grey[600] : "#9ca3af",
    lineHeight: 1.3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  invertedFabMenu: {
    border: "none",
    borderRadius: 50, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    padding: theme.spacing(1),
    backgroundColor: "#F8FAFC",
    color: "#64748B",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:disabled": {
      backgroundColor: "transparent !important",
    },
  },
  invertedFabMenuMP: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "#EFF6FF",
    color: blue[800],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuCont: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    minHeight: "auto",
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "#EFF6FF",
    color: blue[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuMeet: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    minHeight: "auto",
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "#ECFDF5",
    color: green[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuDoc: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "#F5F3FF",
    color: "#7f66ff",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuCamera: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "#FDF2F8",
    color: pink[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  flexContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  flexItem: {
    flex: 1,
  },
}));

const MessageInput = ({
  ticketId,
  ticketStatus,
  droppedFiles,
  contactId,
  whatsappId,
  ticketChannel,
  disableAutoFocus = false
}) => {

  const classes = useStyles();
  const theme = useTheme();
  const [mediasUpload, setMediasUpload] = useState([]);
  const isMounted = useRef(true);
  const [buttonModalOpen, setButtonModalOpen] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const [onDragEnter, setOnDragEnter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [koraxFormModalOpen, setKoraxFormModalOpen] = useState(false);
  const [koraxFormHistoryOpen, setKoraxFormHistoryOpen] = useState(false);
  const { setReplyingMessage, replyingMessage } = useContext(ReplyMessageContext);
  const { setEditingMessage, editingMessage } = useContext(EditMessageContext);
  const { user } = useContext(AuthContext);
  const [appointmentModalOpen, setKoraxFollowUpModalOpen] = useState(false);
const [koraxMenuAnchor, setKoraxMenuAnchor] = useState(null);
  const [locationModalOpen, setLocationModalOpen] = useState(false);

  const [signMessagePar, setSignMessagePar] = useState(false);
  const { get: getSetting } = useCompanySettings();
  const [signMessage, setSignMessage] = useState(true);
  const [privateMessage, setPrivateMessage] = useState(false);
  const [privateMessageInputVisible, setPrivateMessageInputVisible] = useState(false);
  const [senVcardModalOpen, setSenVcardModalOpen] = useState(false);
  const [showModalMedias, setShowModalMedias] = useState(false);

  // KORAX DRAFT V1
  // Rascunho isolado por empresa + usuario + conversa.
  const draftKey =
    user && user.companyId && user.id && ticketId
      ? `korax:draft:${user.companyId}:${user.id}:${ticketId}`
      : null;

  const persistDraft = value => {
    if (!draftKey || editingMessage || privateMessage) return;

    try {
      if (value && value.trim().length > 0) {
        localStorage.setItem(draftKey, value);
      } else {
        localStorage.removeItem(draftKey);
      }
    } catch (err) {
      console.warn("Korax: nao foi possivel salvar o rascunho.", err);
    }
  };

  const { list: listQuickMessages } = useQuickMessages();


  const isMobile = useMediaQuery('(max-width: 767px)'); // Ajuste o valor conforme necessário
  const [placeholderText, setPlaceHolderText] = useState("");

  // Determine o texto do placeholder com base no ticketStatus
  useEffect(() => {
    if (ticketStatus === "open" || ticketStatus === "group") {
      setPlaceHolderText(i18n.t("messagesInput.placeholderOpen"));
    } else {
      setPlaceHolderText(i18n.t("messagesInput.placeholderClosed"));
    }

    // Limitar o comprimento do texto do placeholder apenas em ambientes mobile
    const maxLength = isMobile ? 20 : Infinity; // Define o limite apenas em mobile

    if (isMobile && placeholderText.length > maxLength) {
      setPlaceHolderText(placeholderText.substring(0, maxLength) + "...");
    }
  }, [ticketStatus])

  const {
    selectedMessages,
    setForwardMessageModalOpen,
    showSelectMessageCheckbox } = useContext(ForwardMessageContext);

  useEffect(() => {
    if (droppedFiles && droppedFiles.length > 0) {
      const selectedMedias = Array.from(droppedFiles);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  }, [droppedFiles]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!disableAutoFocus && inputRef.current) {
      inputRef.current.focus();
    }
    if (editingMessage) {
      setInputMessage(editingMessage.body);
    }
  }, [replyingMessage, editingMessage, disableAutoFocus]);

  useEffect(() => {
    if (!disableAutoFocus && inputRef.current) {
      inputRef.current.focus();
    }

    // Recupera o rascunho exclusivo desta conversa.
    try {
      const savedDraft = draftKey
        ? localStorage.getItem(draftKey)
        : null;

      setInputMessage(savedDraft || "");
    } catch (err) {
      console.warn("Korax: nao foi possivel carregar o rascunho.", err);
      setInputMessage("");
    }

    return () => {
      // Nao apagamos o localStorage aqui:
      // o rascunho deve sobreviver a troca de conversa.
      setInputMessage("");
      setShowEmoji(false);
      setMediasUpload([]);
      setReplyingMessage(null);
      //setSignMessage(true);
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false)
      setEditingMessage(null);
    };
  }, [
    ticketId,
    draftKey,
    setReplyingMessage,
    setEditingMessage,
    disableAutoFocus
  ]);

  useEffect(() => {
    if (!disableAutoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [disableAutoFocus]);

  useEffect(() => {
    setTimeout(() => {
      if (isMounted.current)
        setOnDragEnter(false);
    }, 1000);
    // eslint-disable-next-line
  }, [onDragEnter === true]);

  //permitir ativar/desativar firma
  useEffect(() => {
    const fetchSettings = async () => {
      const setting = await getSetting({
        "column": "sendSignMessage"
      });

      if (isMounted.current) {
        if (setting.sendSignMessage === "enabled") {
          setSignMessagePar(true);
          const signMessageStorage = JSON.parse(
            localStorage.getItem("persistentSignMessage")
          );
          if (isNil(signMessageStorage)) {
            setSignMessage(true)
          } else {
            setSignMessage(signMessageStorage);
          }
        } else {
          setSignMessagePar(false);
        }
      }
    };
    fetchSettings();
  }, []);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleSendLinkVideo = async () => {
    const link = `https://meet.jit.si/${ticketId}`;

    setInputMessage(link);
    persistDraft(link);
  }

  const handleChangeInput = (e) => {
    const value = e.target.value;

    setInputMessage(value);
    persistDraft(value);
  };

  const handlePrivateMessage = (e) => {
    setPrivateMessage(!privateMessage);
    setPrivateMessageInputVisible(!privateMessageInputVisible);
  };

  const handleButtonModalOpen = () => {
    handleMenuItemClick();
    setButtonModalOpen(true); // Define o estado como true para abrir o modal
  };

  const handleQuickAnswersClick = async (value) => {
    if (value.mediaPath) {
      try {
        const { data } = await axios.get(value.mediaPath, {
          responseType: "blob",
        });

        handleUploadQuickMessageMedia(data, value.value);
        setInputMessage("");
        return;
        //  handleChangeMedias(response)
      } catch (err) {
        toastError(err);
      }
    }

    setInputMessage("");
    setInputMessage(value.value);
    setTypeBar(false);
  };

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const [modalCameraOpen, setModalCameraOpen] = useState(false);

  const handleCapture = (imageData) => {
    if (imageData) {
      handleUploadCamera(imageData);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    setMediasUpload(selectedMedias);
    setShowModalMedias(true);
  };

  const handleChangeSign = (e) => {
    getStatusSingMessageLocalstogare();
  };

  const handleOpenModalForward = () => {
    if (selectedMessages.length === 0) {
      setForwardMessageModalOpen(false)
      toastError(i18n.t("messagesList.header.notMessage"));
      return;
    }
    setForwardMessageModalOpen(true);
  }

  const getStatusSingMessageLocalstogare = () => {
    const signMessageStorage = JSON.parse(
      localStorage.getItem("persistentSignMessage")
    );
    //si existe uma chave "sendSingMessage"
    if (signMessageStorage !== null) {
      if (signMessageStorage) {
        localStorage.setItem("persistentSignMessage", false);
        setSignMessage(false);
      } else {
        localStorage.setItem("persistentSignMessage", true);
        setSignMessage(true);
      }
    } else {
      localStorage.setItem("persistentSignMessage", false);
      setSignMessage(false);
    }
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      const selectedMedias = Array.from(e.clipboardData.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleInputDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files[0]) {
      const selectedMedias = Array.from(e.dataTransfer.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleUploadMedia = async (mediasUpload) => {
    setLoading(true);
    // e.preventDefault();

    // Certifique-se de que a variável medias esteja preenchida antes de continuar
    if (!mediasUpload.length) {
      console.log("Nenhuma mídia selecionada.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("fromMe", true);
    formData.append("isPrivate", privateMessage ? "true" : "false");
    mediasUpload.forEach((media) => {
      formData.append("body", media.caption);
      formData.append("medias", media.file);
    });

    try {
      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMediasUpload([]);
    setShowModalMedias(false);
    setPrivateMessage(false);
    setPrivateMessageInputVisible(false)
  };

  const handleSendContatcMessage = async (vcard) => {
    setSenVcardModalOpen(false);
    setLoading(true);

    if (isNil(vcard)) {
      setLoading(false);
      return;
    }

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: null,
      quotedMsg: replyingMessage,
      isPrivate: privateMessage ? "true" : "false",
      vCard: vcard,
    };
    try {
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
    setEditingMessage(null);
    setPrivateMessage(false);
    setPrivateMessageInputVisible(false);
  };


  const renderBlockedConversationKorax = () => (
    <div className={classes.blockedConversationBox}>
      <div className={classes.blockedCard}>
        <div className={classes.blockedIcon}>🔒</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className={classes.blockedTitle}>Conversa aguardando ação</div>
          <div className={classes.blockedSubtitle}>
            Conversa aguardando ação para responder com segurança.
          </div>
        </div>
        <button
          type="button"
          className={classes.blockedButton}
          onClick={() => window.dispatchEvent(new CustomEvent("koraxAcceptOrReopenConversation"))}
        >
          Ativar
        </button>
      </div>
    </div>
  );

  const handleSendMessage = async () => {

    if (inputMessage.trim() === "") return;
    setLoading(true);

    const userName = privateMessage
      ? `${user.name} - Mensagem Privada`
      : user.name;

    const sendMessage = inputMessage.trim();

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: (signMessage || privateMessage) && !editingMessage
        ? `*${userName}:*\n${sendMessage}`
        : sendMessage,
      quotedMsg: replyingMessage,
      isPrivate: privateMessage ? "true" : "false",
    };

    try {
      if (editingMessage !== null) {
        await api.post(`/messages/edit/${editingMessage.id}`, message);
      } else {
        await api.post(`/messages/${ticketId}`, message);
      }

      // Apenas uma mensagem normal enviada com sucesso
      // deve eliminar o rascunho daquela conversa.
      if (draftKey && !editingMessage && !privateMessage) {
        try {
          localStorage.removeItem(draftKey);
        } catch (err) {
          console.warn("Korax: nao foi possivel remover o rascunho.", err);
        }
      }

      setInputMessage("");
      setShowEmoji(false);
      setReplyingMessage(null);
      setPrivateMessage(false);
      setEditingMessage(null);
      setPrivateMessageInputVisible(false)
      handleMenuItemClick();

      // KORAX UX: devolve o foco ao campo após enviar,
      // permitindo continuar digitando sem novo clique.
      if (!disableAutoFocus) {
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0);
      }
    } catch (err) {
      // Se o envio falhar, mantemos o texto e o rascunho.
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await Mp3Recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const messages = await listQuickMessages({ companyId, userId: user.id });
      const options = messages.map((m) => {
        let truncatedMessage = m.message;
        if (isString(truncatedMessage) && truncatedMessage.length > 90) {
          truncatedMessage = m.message.substring(0, 90) + "...";
        }
        return {
          value: m.message,
          label: `/${m.shortcode}`,
          preview: truncatedMessage,
          shortcode: m.shortcode,
          mediaPath: m.mediaPath,
        };
      });
      if (isMounted.current) {

        setQuickAnswer(options);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage) &&
      inputMessage.length >= 1
    ) {
      const firstWord = inputMessage.charAt(0);

      if (firstWord === "/") {
        setTypeBar(firstWord.indexOf("/") > -1);

        const filteredOptions = quickAnswers.filter((m) => {
          const search = inputMessage.toLowerCase();
          return (
            m.label.toLowerCase().indexOf(search) > -1 ||
            (m.preview || "").toLowerCase().indexOf(search) > -1
          );
        });
        setTypeBar(filteredOptions);
      } else {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputMessage]);

  const disableOption = () => {
    return (
      loading ||
      recording ||
      (ticketStatus !== "open" && ticketStatus !== "group")
    );
  };

  const handleUploadCamera = async (blob) => {
    setLoading(true);
    try {
      const formData = new FormData();
      const filename = `${new Date().getTime()}.png`;
      formData.append("medias", blob, filename);
      formData.append("body", privateMessage ? `\u200d` : "");
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
    setLoading(false);
  };

  const handleUploadQuickMessageMedia = async (blob, message) => {
    setLoading(true);
    try {
      const extension = blob.type.split("/")[1];

      const formData = new FormData();
      const filename = `${new Date().getTime()}.${extension}`;
      formData.append("medias", blob, filename);
      formData.append("body", privateMessage ? `\u200d${message}` : message);
      formData.append("fromMe", true);

      if (isMounted.current) {
        await api.post(`/messages/${ticketId}`, formData);
      }
    } catch (err) {
      toastError(err);
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };


  const handleUploadAudio = async () => {

    setLoading(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = ticketChannel === "whatsapp" ? `${new Date().getTime()}.mp3` : `${new Date().getTime()}.m4a`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);

      if (replyingMessage?.id) {
        formData.append("quotedMsgId", String(replyingMessage.id));
      }

      if (isMounted.current) {
        await api.post(`/messages/${ticketId}`, formData);
        setReplyingMessage(null);
      }
    } catch (err) {
      toastError(err);
    } finally {
      if (isMounted.current) {
        setLoading(false);
        setRecording(false);
      }
    }
  };

  const handleCloseModalMedias = () => {
    setShowModalMedias(false);
  };
  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event) => {
    setAnchorEl(null);
  };

  const handleSendContactModalOpen = async () => {
    handleMenuItemClick();
    setSenVcardModalOpen(true);
  };

  const handleSendLocation = () => {
    handleMenuItemClick();

    if (ticketChannel !== "whatsapp" || privateMessage) {
      return;
    }

    setLocationModalOpen(true);
  };

  const handleSendLocationMessage = async locationData => {
    setLoading(true);
    try {
      const message = {
        read: 1,
        fromMe: true,
        body: "",
        quotedMsg: replyingMessage,
        isPrivate: privateMessage ? "true" : "false",
        location: locationData
      };

      await api.post(`/messages/${ticketId}`, message);
      setInputMessage("");
      setShowEmoji(false);
      setReplyingMessage(null);
      setEditingMessage(null);
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false);
    } finally {
      setLoading(false);
      setLocationModalOpen(false);
    }
  };

  const handleCameraModalOpen = async () => {
    handleMenuItemClick();
    setModalCameraOpen(true);
  };

  const handleCancelSelection = () => {
    setMediasUpload([]);
    setShowModalMedias(false);
  };

  const renderReplyingMessage = (message) => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          {replyingMessage && (
            <div className={classes.replyginMsgBody}>
              {!message.fromMe && (
                <span className={classes.messageContactName}>
                  {message.contact?.name}
                </span>
              )}
              {message.body}
            </div>
          )
          }
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={disableOption()}
          onClick={() => {
            setReplyingMessage(null);
            setEditingMessage(null);
            setInputMessage("");
          }}
        >
          <Clear className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  if (mediasUpload.length > 0) {
    return (

      <Paper
        elevation={0}
        square
        className={classes.viewMediaInputWrapper}
        onDragEnter={() => setOnDragEnter(true)}
        onDrop={(e) => handleInputDrop(e)}
      >
        {showModalMedias && (
          <MessageUploadMedias
            isOpen={showModalMedias}
            files={mediasUpload}
            onClose={handleCloseModalMedias}
            onSend={handleUploadMedia}
            onCancelSelection={handleCancelSelection}
          />
        )}

      </Paper>
    )
  }
  else {
    return (
      <>
        <KoraxFormSendDialog
          open={koraxFormModalOpen}
          onClose={() => setKoraxFormModalOpen(false)}
          ticketId={ticketId}
        />
        <KoraxFormHistoryDialog
          open={koraxFormHistoryOpen}
          onClose={() => setKoraxFormHistoryOpen(false)}
          onBack={() => setKoraxFormHistoryOpen(false)}
          ticketId={ticketId}
        />

        {modalCameraOpen && (
          <CameraModal
            isOpen={modalCameraOpen}
            onRequestClose={() => setModalCameraOpen(false)}
            onCapture={handleCapture}
          />
        )}
        {senVcardModalOpen && (
          <ContactSendModal
            modalOpen={senVcardModalOpen}
            onClose={(c) => {
              handleSendContatcMessage(c);
            }}
          />
        )}
        {locationModalOpen && (
          <LocationModal
            open={locationModalOpen}
            onClose={() => setLocationModalOpen(false)}
            onSubmit={handleSendLocationMessage}
            defaultAddress={inputMessage}
          />
        )}
        <Paper
          square
          elevation={0}
          className={`${classes.mainWrapper} koraxNoMobileZoom`}
          onDragEnter={() => setOnDragEnter(true)}
          onDrop={(e) => handleInputDrop(e)}
        >
          {(replyingMessage && renderReplyingMessage(replyingMessage)) || (editingMessage && renderReplyingMessage(editingMessage))}
          <div
            className={classes.newMessageBox}
            style={recording && isMobile ? {
              justifyContent: "stretch"
            } : undefined}
          >
            <Hidden only={["sm", "xs"]}>
              <IconButton
                aria-label="emojiPicker"
                component="span"
                disabled={disableOption()}
                onClick={(e) => setShowEmoji((prevState) => !prevState)}
              >
                <Mood className={classes.sendMessageIcons} />
              </IconButton>
              {showEmoji ? (
                <div className={classes.emojiBox}>
                  <ClickAwayListener onClickAway={() => setShowEmoji(false)}>
                    <Picker
                      perLine={16}
                      theme={"light"}
                      i18n={i18n}
                      showPreview={true}
                      showSkinTones={false}
                      onSelect={handleAddEmoji}
                    />
                  </ClickAwayListener>
                </div>
              ) : null}

              <IconButton
                disabled={disableOption()}
                aria-label="uploadMedias"
                component="span"
                onClick={handleOpenMenuClick}
                size="small"
              >
                <AddIcon className={classes.sendMessageIcons} />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuItemClick}
                id="simple-menu"
              >
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-img-button"
                    accept="image/*, video/*, audio/* "
                    // disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-img-button">
                    <Fab
                      aria-label="upload-img"
                      component="span"
                      className={classes.invertedFabMenuMP}
                    >
                      <PermMedia />
                    </Fab>
                    {i18n.t("messageInput.type.imageVideo")}
                  </label>
                </MenuItem>
                <MenuItem onClick={handleCameraModalOpen}>
                  <Fab className={classes.invertedFabMenuCamera}>
                    <CameraAlt />
                  </Fab>
                  {i18n.t("messageInput.type.cam")}
                </MenuItem>
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-doc-button"
                    accept="application/*, text/*"
                    // disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-doc-button">
                    <Fab aria-label="upload-img"
                      component="span" className={classes.invertedFabMenuDoc}>
                      <Description />
                    </Fab>
                    Documento
                  </label>
                </MenuItem>
                <MenuItem onClick={handleSendContactModalOpen}>
                  <Fab className={classes.invertedFabMenuCont}>
                    <Person />
                  </Fab>
                  {i18n.t("messageInput.type.contact")}
                </MenuItem>
                <MenuItem
                  onClick={handleSendLocation}
                  disabled={
                    disableOption() ||
                    ticketChannel !== "whatsapp" ||
                    privateMessage
                  }
                >
                  <Fab className={classes.invertedFabMenuCont}>
                    <Room />
                  </Fab>
                  {i18n.t("messageInput.type.location")}
                </MenuItem>
                <MenuItem onClick={handleSendLinkVideo}>
                  <Fab className={classes.invertedFabMenuMeet}>
                    <Duo />
                  </Fab>
                  {i18n.t("messageInput.type.meet")}
                </MenuItem>
                {buttonModalOpen && (
          <ButtonModal
            modalOpen={buttonModalOpen}
            onClose={() => setButtonModalOpen(false)} // Função para fechar o modal
            ticketId={ticketId}
          />
        )}
                <MenuItem
                  disabled={
                    disableOption() ||
                    privateMessage ||
                    ticketChannel !== "whatsapp"
                  }
                  onClick={() => {
                    handleMenuItemClick();
                    setKoraxFormModalOpen(true);
                  }}
                >
                  <Description style={{
                    marginRight: 12,
                    color: "#0057FF"
                  }} />
                  Formulários
                </MenuItem>
                <MenuItem onClick={handleButtonModalOpen}>
                  <Fab className={classes.invertedFabMenuCont}>
                    <MenuIcon />
                  </Fab>
                  Botões
                </MenuItem>
              </Menu>
              {/* <IconButton
				  aria-label="upload"
				  component="span"
				  disabled={disableOption()}
				  onMouseOver={() => setOnDragEnter(true)}
				>
				  <AttachFile className={classes.sendMessageIcons} />
				</IconButton> */}

              {/* </label> */}
              {signMessagePar && (
                <Tooltip title={i18n.t("messageInput.tooltip.signature")}>
                  <IconButton
                    aria-label="send-upload"
                    component="span"
                    onClick={handleChangeSign}
                  >
                    {signMessage === true ? (
                      <Create style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                    ) : (
                      <Create style={{ color: "grey" }} />
                    )}
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title={i18n.t("messageInput.tooltip.privateMessage")}>
                <IconButton
                  aria-label="send-upload"
                  component="span"
                  onClick={handlePrivateMessage}
                >
                  {privateMessage === true ? (
                    <Comment style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                  ) : (
                    <Comment style={{ color: "grey" }} />
                  )}
                </IconButton>
              </Tooltip>
              {/* <Tooltip title={i18n.t("messageInput.tooltip.meet")}>
                <IconButton
                  aria-label="send-upload"
                  component="span"
                  onClick={handleSendLinkVideo}
                >
                  <Duo style={{ color: "grey" }} />
                </IconButton>
              </Tooltip> */}
            </Hidden>
            <Hidden only={["md", "lg", "xl"]}>
              <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleOpenMenuClick}
              >
                <MoreVert></MoreVert>
              </IconButton>
              <Menu
                id="simple-menu"
                keepMounted
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuItemClick}
              >
                <MenuItem onClick={handleMenuItemClick}>
                  <IconButton
                    aria-label="emojiPicker"
                    component="span"
                    disabled={disableOption()}
                    onClick={(e) => setShowEmoji((prevState) => !prevState)}
                  >
                    <Mood className={classes.sendMessageIcons} />
                  </IconButton>
                </MenuItem>
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-button"
                    disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-button">
                    <IconButton
                      aria-label="upload"
                      component="span"
                      disabled={disableOption()}
                    >
                      <AttachFile className={classes.sendMessageIcons} />
                    </IconButton>
                  </label>
                </MenuItem>
                <MenuItem
                  disabled={
                    disableOption() ||
                    privateMessage ||
                    ticketChannel !== "whatsapp"
                  }
                  onClick={() => {
                    handleMenuItemClick();
                    setKoraxFormModalOpen(true);
                  }}
                >
                  <Description style={{
                    marginRight: 12,
                    color: "#0057FF"
                  }} />
                  Formulários
                </MenuItem>
                <MenuItem onClick={handleSendLocation}>
                  <IconButton
                    aria-label="sendLocation"
                    component="span"
                    disabled={
                      disableOption() ||
                      ticketChannel !== "whatsapp" ||
                      privateMessage
                    }
                  >
                    <Room className={classes.sendMessageIcons} />
                  </IconButton>
                </MenuItem>
                {signMessagePar && (
                  <Tooltip title="Habilitar/Desabilitar Assinatura">
                    <IconButton
                      aria-label="send-upload"
                      component="span"
                      onClick={handleChangeSign}
                    >
                      {signMessage === true ? (
                        <Create style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                      ) : (
                        <Create style={{ color: "grey" }} />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Habilitar/Desabilitar Comentários">
                  <IconButton
                    aria-label="send-upload"
                    component="span"
                    onClick={handlePrivateMessage}
                  >
                    {privateMessage === true ? (
                      <Comment style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                    ) : (
                      <Comment style={{ color: "grey" }} />
                    )}
                  </IconButton>
                </Tooltip>
              </Menu>
            </Hidden>
            <div
              className={classes.flexContainer}
              style={recording && isMobile ? {
                display: "none"
              } : undefined}
            >
              {privateMessageInputVisible && (
                <div className={classes.flexItem}>
                  <div className={classes.messageInputWrapperPrivate}>
                    <InputBase
                      inputRef={(input) => {
                        input && (inputRef.current = input);
                      }}
                      className={classes.messageInputPrivate}
                      placeholder={
                        ticketStatus === "open" || ticketStatus === "group"
                          ? i18n.t("messagesInput.placeholderPrivateMessage")
                          : i18n.t("messagesInput.placeholderClosed")
                      }
                      multiline
                      maxRows={5}
                      value={inputMessage}
                      onChange={handleChangeInput}
                      disabled={disableOption()}
                      onPaste={(e) => {
                        (ticketStatus === "open" || ticketStatus === "group") &&
                          handleInputPaste(e);
                      }}
                      onKeyPress={(e) => {
                        if (loading || e.shiftKey) return;
                        else if (e.key === "Enter") {
                          handleSendMessage();
                        }
                      }}

                    />
                    {typeBar ? (
                      <ClickAwayListener onClickAway={() => setTypeBar(false)}>
                        <ul className={classes.messageQuickAnswersWrapper}>
                        {typeBar.map((value, index) => {
                          return (
                            <li
                              className={classes.messageQuickAnswersWrapperItem}
                              key={index}
                            >
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a
                                className={classes.messageQuickAnswerLink}
                                onClick={() => handleQuickAnswersClick(value)}
                              >
                                <span className={classes.messageQuickAnswerShortcut}>
                                  {value.label}
                                </span>
                                <span className={classes.messageQuickAnswerPreview}>
                                  {value.preview || value.value}
                                </span>
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                      </ClickAwayListener>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              )}
              {!privateMessageInputVisible && (
                <div className={classes.flexItem}>
                  <div className={classes.messageInputWrapper}>
                    <InputBase
                      inputRef={(input) => {
                        input && (inputRef.current = input);
                      }}
                      className={classes.messageInput}
                      placeholder={placeholderText}
                      multiline
                      maxRows={5}
                      value={inputMessage}
                      onChange={handleChangeInput}
                      disabled={disableOption()}
                      onPaste={(e) => {
                        (ticketStatus === "open" || ticketStatus === "group") &&
                          handleInputPaste(e);
                      }}
                      onKeyPress={(e) => {
                        if (loading || e.shiftKey) return;
                        else if (e.key === "Enter") {
                          handleSendMessage();
                        }
                      }}
                    />
                    {typeBar ? (
                      <ClickAwayListener onClickAway={() => setTypeBar(false)}>
                        <ul className={classes.messageQuickAnswersWrapper}>
                        {typeBar.map((value, index) => {
                          return (
                            <li
                              className={classes.messageQuickAnswersWrapperItem}
                              key={index}
                            >
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a
                                className={classes.messageQuickAnswerLink}
                                onClick={() => handleQuickAnswersClick(value)}
                              >
                                <span className={classes.messageQuickAnswerShortcut}>
                                  {value.label}
                                </span>
                                <span className={classes.messageQuickAnswerPreview}>
                                  {value.preview || value.value}
                                </span>
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                      </ClickAwayListener>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {!privateMessageInputVisible && (
              <>
                <div style={{
                  display: recording && isMobile ? "none" : "contents"
                }}>
                <button
                  type="button"
                  title="Respostas rápidas"
                  aria-label="Respostas rápidas"
                  onClick={() => {
                    setTypeBar(
                      quickAnswers.length > 0
                        ? quickAnswers
                        : false
                    );

                    setTimeout(() => {
                      if (inputRef.current) {
                        inputRef.current.focus();
                      }
                    }, 0);
                  }}
                  style={{
                    border: "1px solid #DCE6F5",
                    background: "#FFFFFF",
                    color: "#155EEF",
                    borderRadius: 12,
                    padding: "6px 9px",
                    minHeight: 36,
                    fontWeight: 800,
                    fontSize: 11.5,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    boxShadow: "0 4px 12px rgba(15,23,42,.06)",
                    whiteSpace: "nowrap",
                    flexShrink: 0
                  }}
                >
                  <span
                    style={{
                      fontSize: 15,
                      lineHeight: 1
                    }}
                  >
                    ⚡
                  </span>
                  Respostas
                </button>

                <button
                    type="button"
                    data-guide="ticket-korax-powers"
                    onClick={(e) => setKoraxMenuAnchor(e.currentTarget)}
                    title="Ações desta conversa"
                    style={{
                      border: "1px solid #DCE6F5",
                      background: "#FFFFFF",
                      color: "#155EEF",
                      borderRadius: 12,
                      padding: "6px 10px 6px 7px",
                      minHeight: 36,
                      fontWeight: 750,
                      fontSize: 11.5,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 7,
                      marginRight: 6,
                      boxShadow: "0 4px 12px rgba(15,23,42,.06)",
                      whiteSpace: "nowrap",
                      flexShrink: 0
                    }}
                  >
                    <span
                      style={{
                        width: 23,
                        height: 23,
                        borderRadius: 8,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#155EEF",
                        color: "#FFFFFF",
                        fontSize: 10,
                        fontWeight: 900
                      }}
                    >
                      K
                    </span>
                    Korax
                  </button>

                <Menu
                    anchorEl={koraxMenuAnchor}
                    keepMounted
                    open={Boolean(koraxMenuAnchor)}
                    onClose={() => setKoraxMenuAnchor(null)}
                    PaperProps={{
                      style: {
                        borderRadius: 16,
                        minWidth: 292,
                        padding: "4px 0 7px",
                        border: "1px solid #E5EAF2",
                        boxShadow: "0 18px 45px rgba(15,23,42,.14)",
                        overflow: "hidden"
                      }
                    }}
                  >
                    <div
                      style={{
                        padding: "10px 14px 8px",
                        borderBottom: "1px solid #EEF2F7",
                        marginBottom: 4
                      }}
                    >
                      <div
                        style={{
                          color: "#0F172A",
                          fontSize: 12.5,
                          fontWeight: 800
                        }}
                      >
                        Ações da conversa
                      </div>
                      <div
                        style={{
                          color: "#94A3B8",
                          fontSize: 10.5,
                          marginTop: 2
                        }}
                      >
                        Atalhos para conduzir este atendimento
                      </div>
                    </div>

                    <MenuItem
                      onClick={() => {
                        setKoraxFollowUpModalOpen(true);
                        setKoraxMenuAnchor(null);
                      }}
                      style={{
                        margin: "3px 7px",
                        padding: "9px 10px",
                        borderRadius: 11,
                        gap: 10
                      }}
                    >
                      <div
                        style={{
                          width: 34,
                          height: 34,
                          borderRadius: 10,
                          background: "#EFF6FF",
                          color: "#155EEF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 850,
                          fontSize: 12,
                          flexShrink: 0
                        }}
                      >
                        F
                      </div>

                      <div>
                        <div style={{ color: "#0F172A", fontSize: 12.5, fontWeight: 750 }}>
                          Agendar follow-up
                        </div>
                        <div style={{ color: "#64748B", fontSize: 10.5, marginTop: 1 }}>
                          Defina quando retomar este contato
                        </div>
                      </div>
                    </MenuItem>

                    <MenuItem
                      onClick={() => {
                        window.dispatchEvent(
                          new CustomEvent("koraxOpenOpportunity")
                        );
                        setKoraxMenuAnchor(null);
                      }}
                      style={{
                        margin: "3px 7px",
                        padding: "9px 10px",
                        borderRadius: 11,
                        gap: 10
                      }}
                    >
                      <div
                        style={{
                          width: 34,
                          height: 34,
                          borderRadius: 10,
                          background: "#ECFDF3",
                          color: "#15803D",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 850,
                          fontSize: 10,
                          flexShrink: 0
                        }}
                      >
                        R$
                      </div>

                      <div>
                        <div style={{ color: "#0F172A", fontSize: 12.5, fontWeight: 750 }}>
                          Registrar oportunidade
                        </div>
                        <div style={{ color: "#64748B", fontSize: 10.5, marginTop: 1 }}>
                          Crie ou acompanhe uma negociação
                        </div>
                      </div>
                    </MenuItem>

                    <MenuItem
                      disabled={!ticketId}
                      onClick={() => {
                        setKoraxMenuAnchor(null);
                        setKoraxFormModalOpen(true);
                      }}
                      style={{
                        margin: "3px 7px",
                        padding: "9px 10px",
                        borderRadius: 10,
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        minHeight: 49
                      }}
                    >
                      <div
                        style={{
                          width: 33,
                          height: 33,
                          borderRadius: 10,
                          background: "#EDF3FF",
                          color: "#0057FF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 18,
                          fontWeight: 800,
                          flexShrink: 0
                        }}
                      >
                        ▤
                      </div>

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{
                          color: "#0F172A",
                          fontSize: 12.5,
                          fontWeight: 750
                        }}>
                          Formulários
                        </div>
                        <div style={{
                          color: "#64748B",
                          fontSize: 10.5,
                          marginTop: 1
                        }}>
                          Enviar, acompanhar e importar respostas
                        </div>
                      </div>

                      <KoraxFormPendingBadge
                        ticketId={ticketId}
                        open={Boolean(koraxMenuAnchor)}
                      />
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.dispatchEvent(
                          new CustomEvent("koraxOpenMission")
                        );
                        setKoraxMenuAnchor(null);
                      }}
                      style={{
                        margin: "3px 7px",
                        padding: "9px 10px",
                        borderRadius: 11,
                        gap: 10
                      }}
                    >
                      <div
                        style={{
                          width: 34,
                          height: 34,
                          borderRadius: 10,
                          background: "#F5F3FF",
                          color: "#6D28D9",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 850,
                          fontSize: 10,
                          flexShrink: 0
                        }}
                      >
                        IA
                      </div>

                      <div>
                        <div style={{ color: "#0F172A", fontSize: 12.5, fontWeight: 750 }}>
                          Próxima ação com IA
                        </div>
                        <div style={{ color: "#64748B", fontSize: 10.5, marginTop: 1 }}>
                          Receba uma sugestão para avançar
                        </div>
                      </div>
                    </MenuItem>
                  </Menu>
                
                </div>
                {inputMessage || showSelectMessageCheckbox ? (
                  <>
                    <IconButton
                      aria-label="sendMessage"
                      component="span"
                      onClick={showSelectMessageCheckbox ? handleOpenModalForward : handleSendMessage}
                      disabled={loading}
                    >
                      {showSelectMessageCheckbox ?
                        <Reply className={classes.ForwardMessageIcons} /> : <Send className={classes.sendMessageIcons} />}
                    </IconButton>
                  </>
                ) : recording ? (
                  <div className={classes.recorderWrapper}>
                    <IconButton
                      aria-label="cancelRecording"
                      component="span"
                      fontSize="large"
                      disabled={loading}
                      onClick={handleCancelAudio}
                    >
                      <HighlightOff className={classes.cancelAudioIcon} />
                    </IconButton>
                    {loading ? (
                      <div>
                        <CircularProgress className={classes.audioLoading} />
                      </div>
                    ) : (
                      <RecordingTimer />
                    )}

                    <IconButton
                      aria-label="sendRecordedAudio"
                      component="span"
                      onClick={handleUploadAudio}
                      disabled={loading}
                    >
                      <CheckCircleOutline className={classes.sendAudioIcon} />
                    </IconButton>
                  </div>
                ) : (
                  <IconButton
                    aria-label="showRecorder"
                    component="span"
                    disabled={disableOption()}
                    onClick={handleStartRecording}
                  >
                    <Mic className={classes.sendMessageIcons} />
                  </IconButton>
                )}
              </>
            )}

            {privateMessageInputVisible && (
              <>
                <IconButton
                  aria-label="sendMessage"
                  component="span"
                  onClick={showSelectMessageCheckbox ? handleOpenModalForward : handleSendMessage}
                  disabled={loading}
                >
                  {showSelectMessageCheckbox ?
                    <Reply className={classes.ForwardMessageIcons} /> : <Send className={classes.sendMessageIcons} />}
                </IconButton>
              </>
            )}
            {appointmentModalOpen && (
              <KoraxFollowUpModal
                open={appointmentModalOpen}
                onClose={() => setKoraxFollowUpModalOpen(false)}
                message={inputMessage}
                ticketId={ticketId}
                contactId={contactId}
                whatsappId={whatsappId}
              />
            )}
          </div>
        </Paper>
      </>
    );
  }
};

export default MessageInput;
